import { defineNuxtPlugin } from '#app'
import { Media } from './media'

export default defineNuxtPlugin(nuxtApp => {
  // TODO: Пересмотреть брейкпоинты при рефакторинге лаяута
  const media = new Media({
    breakpoints: {
      sm: 568,
      md: 784,
      lg: 960
    } as const
  })

  // https://nuxt.com/docs/api/advanced/hooks
  nuxtApp.hook('app:suspense:resolve', () => {
    media.enable()
  })

  return {
    provide: {
      matchMedia: media
    }
  }
})
